import api from './api';

const clientMessageService = {

  async getMyConversations() {
    const response = await api.get('/client/messages/conversations');
    return response.data;
  },

  async getConversationMessages(conversationId) {
    const response = await api.get(`/client/messages/conversations/${conversationId}/messages`);
    return response.data;
  },

  async sendMessage(salonId, content) {
    const response = await api.post('/client/messages/send', { salonId, content });
    return response.data;
  },

  async markAsRead(conversationId) {
    const response = await api.put(`/client/messages/conversations/${conversationId}/read`);
    return response.data;
  },

  async getUnreadCount() {
    const response = await api.get('/client/messages/unread-count');
    return response.data;
  }

};

export default clientMessageService;